import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { useStore } from '../../../../hooks';

interface TournamentFrameProps {
  isOpen: boolean;
}

export const TournamentFrame: React.FC<TournamentFrameProps> = observer(({ isOpen }) => {

  const { tournamentStore, gameStore, postMessageStore, userActivityStore } = useStore();
  const { launchData: { data: launchData } } = gameStore;

  const [tournamentFrameSource, setTournamentFrameSource] = useState('');

  useEffect(() => {
    if (launchData) {
      // generating tournament launch url
      const src = tournamentStore.generateLaunchUrl(launchData);
      setTournamentFrameSource(src);
    }
  }, [launchData]);

  const refCallback = useCallback((element: HTMLIFrameElement) => {
    postMessageStore.setTournamentIframeElement(element);
    userActivityStore.attachEventListeners(element?.contentWindow);
  }, []);

  return (
    tournamentFrameSource ? (
      <iframe
        ref={refCallback}
        src={tournamentFrameSource}
        title="Pascal Gaming Tournament Frame"
        allow="fullscreen; clipboard-read; clipboard-write"
        className={`tournament-frame ${isOpen ? 'open' : ''}`}
        sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-forms allow-scripts allow-top-navigation"
      />
    ) : null
  );
});
